// For Entities Context
export const DASHBOARD_CONTEXT = 'DASHBOARD';
export const SET_ENTITIES = 'SET_ENTITIES';
export const SET_PAGINATED_ENTITIES = 'SET_PAGINATED_ENTITIES';
export const SET_SEARCH = 'SET_SEARCH';
export const SET_PER_PAGE = 'SET_PER_PAGE';
export const SET_CUSTOM_PAGE = 'SET_CUSTOM_PAGE';
export const SET_FILTERS = "SET_FILTERS";
export const SET_LOADING = 'SET_LOADING';
